import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { IModel } from "./EmailTemplate";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import React from 'react';
import { EmptyEmailTemplate } from "./EmptyEmailTemplate";
import ReadMoreTableComponent from "./readMoreTableComponent";
import { IEmailTemplate } from "../../models/BaseModel";
import { format } from "date-fns";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmailTemplate>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    // const [expand,setExpand]=useState(false);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);
    const dt = useRef<any>(null);
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Email_Template", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {

            const data: Array<IEmailTemplate> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyEmailTemplate });
    };
    const openEdit = (rowDatauser: IEmailTemplate) => {
        props.setModal({ open: true, singleData: rowDatauser });
        // console.log(rowDatauser)
    };

    const renderContent = (rowData: IEmailTemplate | any) => {
        // const content = rowData.templateBody;
        const content = rowData.templateBody
            ? rowData.templateBody.replace(/<[^>]*>/g, "") // remove all HTML tags
            : "";
        if (content.length > 50) {
            let xy = content.substring(0, 50);
            let yz = content;
            return <ReadMoreTableComponent less={xy} more={yz} />
        } else {
            return content;
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Email Template</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    // const handleReadMore = () => {
    //     setExpand(!expand);
    //   };

    // const render = (rowData: IEmailTemplate |any) => {
    //     const content = rowData.template_Body;
    //     if (content) {
    //         let xy=content.substring(0, 50);

    //     return (
    //         <>
    //         {expand ? <p>{rowData.template_Body}</p> : xy}
    //   <Link onClick={handleReadMore} to={""}>{expand ? 'Show Less' : 'Read More'}</Link>
    //   </>
    //     );
    //     };

    // };

    const actionBodyTemplate = (rowData: IEmailTemplate) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    const createdAtBody = (rowData: any) => {
        return (
            <span>{rowData.createdAt ? format(new Date(rowData.createdAt), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                ref={dt}
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="templateName" header="Template Name" />
                <Column field="templateSubject" header="Template Subject" />
                <Column field="templateBody" header="Template Body" body={renderContent} />
                <Column field="createdAt" header="Created At " body={createdAtBody} />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
